var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{attrs:{"variant":"primary","disabled":_vm.disabled || _vm.spinning},on:{"click":function($event){$event.preventDefault();return _vm.on_click.apply(null, arguments)}}},[(_vm.spinning)?_c('memlist-spinner'):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }